document.addEventListener("DOMContentLoaded", () => {
  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function checkCookie(name) {
    return document.cookie.split(";").some((c) => c.trim().startsWith(name + "="));
  }

  const selectors = {
    timeoutPopup: "#timeoutPopup",
    magnetPopup: "#magnetPopup",
    popupClose: "[data-close-popup]",
    form: "[data-newsletter-form]",
    firstStep: "[data-first-step]",
    secondStep: "[data-second-step]",
    copyBtn: "[data-copy]",
    copyBtnInput: "[data-copy-input]",
    copyBtnTooltip: "[data-tooltip]",

    // ✅ добавь в верстку блок под ошибки:
    // <div data-form-error class="form-error hidden"></div>
    errorBox: "[data-form-error]",
  };

  // ✅ URL твоего worker (вставь свой)
  const WORKER_URL = "https://hebslab.vanzonice7777.workers.dev/";

  const form = document.querySelector(selectors.form);
  if (!form) return;

  const emailInput = form.querySelector('input[type="email"]');
  const submitBtn = form.querySelector("button");
  const firstStep = document.querySelector(selectors.firstStep);
  const secondStep = document.querySelector(selectors.secondStep);

  const copyBtn = document.querySelector(selectors.copyBtn);
  const copyBtnInput = document.querySelector(selectors.copyBtnInput);
  const copyBtnTooltip = document.querySelector(selectors.copyBtnTooltip);

  const errorBox = form.querySelector(selectors.errorBox) || document.querySelector(selectors.errorBox);

  const COOKIE_NAME = copyBtnInput?.value ? `show-${copyBtnInput.value}` : "show-popup";

  function showError(message) {
    if (!errorBox) {
      alert(message);
      return;
    }
    errorBox.textContent = message;
    errorBox.classList.remove("hidden");
  }

  function clearError() {
    if (!errorBox) return;
    errorBox.textContent = "";
    errorBox.classList.add("hidden");
  }

  function setLoading(isLoading) {
    if (!submitBtn) return;
    if (isLoading) {
      submitBtn.dataset.originalText = submitBtn.innerHTML;
      submitBtn.innerHTML = `Loading data...`;
      submitBtn.disabled = true;
    } else {
      submitBtn.innerHTML = submitBtn.dataset.originalText || "Submit";
      submitBtn.disabled = false;
    }
  }

  function showPopup(selector) {
    const popup = document.querySelector(selector);
    if (!popup) return;
    if (popup && !checkCookie(COOKIE_NAME)) {
        setCookie(COOKIE_NAME, "true", 30);
        popup.classList.add('open');
        document.body.classList.add('overflow-hidden');
    }
  }

  function closePopup(selector) {
    const popup = document.querySelector(selector);
    if (!popup) return;

    popup.classList.remove("open");
    document.body.classList.remove("overflow-hidden");
  }

  document.addEventListener("click", (e) => {
    const popupClose = e.target.closest(selectors.popupClose);
    const popupBg = e.target === document.querySelector(selectors.timeoutPopup);

    if (!popupClose && !popupBg) return;

    e.preventDefault();
    closePopup(selectors.timeoutPopup);
  });

  // ✅ отправка в Worker + обработка ответов
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    clearError();

    const email = (emailInput?.value || "").trim().toLowerCase();

    if (!email) {
      showError("Please enter your email.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(WORKER_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({
          email,
          newsletter: true,
          source: "popup",
        }),
      });

      // Пытаемся распарсить JSON даже на ошибках
      let data = null;
      const text = await res.text();
      try {
        data = text ? JSON.parse(text) : null;
      } catch {
        data = null;
      }

      // ❌ Network / server error
      if (!res.ok) {
        const code = data?.code || data?.error || "ERROR";
        const msg =
          data?.message ||
          data?.error ||
          "Something went wrong. Please try again.";

        // Специальные кейсы
        if (code === "ALREADY_SUBSCRIBED") {
          showError("This email is already subscribed.");
        } else if (res.status === 400) {
          showError(msg); // например "Invalid email"
        } else {
          showError(msg);
        }

        return; // ✅ step2 НЕ показываем
      }

      // ✅ success
      // можно использовать data.action: created/updated
      firstStep?.classList.add("hidden");
      secondStep?.classList.remove("hidden");

      // (опционально) можно поставить куку, что уже подписался
      // setCookie(COOKIE_NAME, "true", 30);

    } catch (err) {
      showError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  });

  // Copy promo
  if (copyBtn && copyBtnInput && copyBtnTooltip) {
    copyBtn.addEventListener("click", () => {
      copyBtnInput.select();
      copyBtnInput.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(copyBtnInput.value);

      copyBtnTooltip.classList.add("show");
      setTimeout(() => copyBtnTooltip.classList.remove("show"), 2000);
    });
  }

  // Show popup after 3s
  setTimeout(() => {
    const magnetPopup = document.querySelector(selectors.magnetPopup);
    if (magnetPopup && magnetPopup.classList.contains("open")) return;

    showPopup(selectors.timeoutPopup);
  }, 30000);
});
